import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translations at build time
import ar from './locales/ar.json';
import ca from './locales/ca.json';
import cs from './locales/cs.json';
import da from './locales/da.json';
import de from './locales/de.json';
import el from './locales/el.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fi from './locales/fi.json';
import fr from './locales/fr.json';
import he from './locales/he.json';
import hi from './locales/hi.json';
import hr from './locales/hr.json';
import hu from './locales/hu.json';
import id from './locales/id.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ms from './locales/ms.json';
import nl from './locales/nl.json';
import no from './locales/no.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import ro from './locales/ro.json';
import ru from './locales/ru.json';
import sk from './locales/sk.json';
import sv from './locales/sv.json';
import th from './locales/th.json';
import tr from './locales/tr.json';
import uk from './locales/uk.json';
import vi from './locales/vi.json';
import zh from './locales/zh.json';

export const LANGUAGE_STORAGE_KEY = 'tripreel-language';

export const supportedLanguages = [
  'ar', 'ca', 'cs', 'da', 'de', 'el', 'en', 'es', 'fi', 'fr',
  'he', 'hi', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'ms', 'nl',
  'no', 'pl', 'pt', 'ro', 'ru', 'sk', 'sv', 'th', 'tr', 'uk',
  'vi', 'zh'
];

export const rtlLanguages = ['ar', 'he'];

const allTranslations = {
  ar, ca, cs, da, de, el, en, es, fi, fr,
  he, hi, hr, hu, id, it, ja, ko, ms, nl,
  no, pl, pt, ro, ru, sk, sv, th, tr, uk,
  vi, zh
};

// Build all resources at once
const allResources = {};
supportedLanguages.forEach(lang => {
  allResources[lang] = { translation: allTranslations[lang] };
});

// Initialize synchronously with ALL resources - needed for prerendering to work
export const initializeI18nSync = (initialLanguage = 'en') => {
  i18n
    .use(initReactI18next)
    .init({
      resources: allResources,
      lng: initialLanguage,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: false
      }
    });

  return i18n;
};

// Change language - synchronous, instant
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
};

export default i18n;
